import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import {Validate} from "../../core/form/validate";
import {MdTextField} from "../../core/components/fields/fields";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "../../core/form/closedForm";
import {DefinitionType} from "../../core/form/form";
import {createForm} from "../../core/form/createForm";
import StyledSelect from "../../core/components/fields/styledSelect";
import {optionsSearch} from "../../core/common/service/commonDataService";
import {ProjectVersionEnergyCarrier} from "../domain/project/projectVersionEnergyCarrierDomain";
import {ENERGY_CARRIER_ENTITY} from "../entityConstants";
import {ProjectVersion} from "../domain/project/projectVersionDomain";

@observer
class ProjectVersionEnergyCarrierForm extends React.Component<FormProps<ProjectVersionEnergyCarrier, ProjectVersion>, undefined> {


  render() {

    let {dataObject, rootObject, entities, entity} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionEnergyCarrierFormDefinition.formName);
    let {originalEnergyCarrier, energyConsumption, type} = fields;
console.log("ProjectVersionEnergyCarrierForm props", this.props)
    return (
      <div>
        <div className="row">
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...originalEnergyCarrier.props} async={true} asterixForAll loadOptions={optionsSearch.bind(this, ENERGY_CARRIER_ENTITY, {})} clearable={true} />
            <Validate field={originalEnergyCarrier} value={originalEnergyCarrier.props.value}/>
          </div>

          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...type.props} />
            <Validate field={type} value={type.props.value}/>
          </div>

          <div className="fx col-xs-6 col-sm-4">
            <MdTextField {...energyConsumption.props} />
            <Validate field={energyConsumption} value={energyConsumption.props.value}/>
          </div>
        </div>
      </div>
    );
  }
}


const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<ProjectVersionEnergyCarrier>) => (
  <div style={{width: '100%'}}>
    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
      <ClosedFormField label={fields.originalEnergyCarrier.textLabel} value={dataObject.originalEnergyCarrier}/>
      <ClosedFormField label={fields.type.textLabel} value={dataObject.type}/>
      <ClosedFormField label={fields.energyConsumption.textLabel} value={dataObject.energyConsumption}/>
    </ClosedFormBlock>
  </div>
);


export const ProjectVersionEnergyCarrierFormDefinition: DefinitionType = {
  formName: 'ProjectEnergyCarrierForm',
  fields: [{
    name: 'type',
    validators: ['IsRequired']
  }, {
    name: 'energyConsumption',
    validators: ['IsRequired', 'IsNumber' ]
  }, {
    name: 'originalEnergyCarrier',
    validators: ['IsRequired']
  }]
};

export default createForm(ProjectVersionEnergyCarrierFormDefinition, ClosedContent)(ProjectVersionEnergyCarrierForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionEnergyCarrierForm.tsx